import { operationsAjax } from '../ajax/OperationsAjax'
import { PagedResult } from '../DTOs/Common/PagedResult'
import { StoppageCalc } from '../DTOs/Stoppage/StoppageCalc'
import { queryClient } from '../queryClient'
import { store } from '../state/store'
import { computeShiftId } from './computeShiftId'
import { enqueue } from './queueOps'
import { isOnlineNow } from './connectivity'

function currentShiftId(): number {
  const { selectedDate, selectedShift } = store.getState().shift
  return computeShiftId(selectedDate, selectedShift)
}

function provisionalPlantId(operationId: number): number | undefined {
  if (operationId >= 0) return undefined

  for (const [, page] of queryClient.getQueriesData<PagedResult<StoppageCalc>>({
    queryKey: ['dataTable', 'operations', 'stoppageCalcs'],
  })) {
    const match = (page?.data ?? []).find(row => row?.operationId === operationId)
    if (match?.plantId) return match.plantId
  }
  return undefined
}

export const engineHoursMutations = {
  async updateEngineHours(operationId: number, startHours: number, endHours: number) {
    if (isOnlineNow()) return operationsAjax.updateEngineHours(operationId, startHours, endHours)

    await enqueue({
      entity: 'engineHours',
      operation: 'update',
      shiftId: currentShiftId(),
      entityId: operationId,
      data: {
        operationId,
        startEngineHours: startHours,
        endEngineHours: endHours,
        operationPlantId: provisionalPlantId(operationId),
      },
    })

    return { success: true, data: null }
  },
}
